import React, { useState, useEffect } from "react";
import "../../styles/stepper.css";
import {
  stepperData,
  deviceProblem,
  deliveryCat,
  referenceData,
} from "../../constants/stepper";
import { useNavigate } from "react-router-dom";
import ArrowDown from "../../utils/assets/down.svg";
import closeSVG from "../../utils/assets/close.svg";
import nextSVG from "../../utils/assets/next.svg";
import prevSVG from "../../utils/assets/back.svg";
import toRigthIcon from "../../utils/assets/toRight.svg";
import { Link } from "react-router-dom";
import UserNavbar from "../../components/users/UserNavbar";
import {
  fetchDevices,
  fetchBrands,
  fetchModels,
  fetchDefects,
  CreateLead,
} from "../../actions/client/devices";
import { toast } from "react-toastify";

const InqueryForm = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [openSelect, setOpenSelect] = useState(false);
  const [searchIssue, setSearchIssue] = useState("");
  const steps = ["Step 1", "Step 2", "Step 3", "Step 4"];
  const [deviceType, setDeviceType] = useState("serial_no");
  const [triggerInput, setTriggerinput] = useState(false);
  const [compliance, setCompliance] = useState(false);
  const [serialNo, setSerialNo] = useState("");
  const [formData, setFormdata] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address: "",
    zip_code: "",
    city: "",
    state: "",
    country: "",
    message: "",
    reference: "",
  });
  const [categoryForm, setCategoryForm] = useState({
    category: "",
    brand: "",
    model: "",
  });
  const [deliveryType, setDeliveryType] = useState("");
  const [selectedProblems, setSelectedProblems] = useState([]);
  const [errorDefect, setErrorDefect] = useState("");
  const [otherModel, setOtherModel] = useState({
    isSelected: false,
    modelName: "",
  });
  const [devices, setDevices] = useState([]);
  const [brandsData, setBrandsData] = useState([]);
  const [models, setModels] = useState([]);
  const [ids, setIds] = useState({
    category_id: Number,
    brand_id: Number,
    modal_id: Number,
  });
  const [defectsList, setDefectsList] = useState([]);
  const deliveryTypeSubmit = (data) => {
    setDeliveryType(data);
    setCurrentStep(3);
    console.log(deliveryType);
  };

  const navigate = useNavigate();

  const handleChangeSelect = (e) => {
    setFormdata((prevState) => ({
      ...prevState,
      reference: e.target.value,
    }));
  };

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  function triggerData(data) {
    setDeviceType(data);
    setTriggerinput(false);
  }
  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleCategoryClick = (category, id) => {
    setCategoryForm((prevData) => ({
      ...prevData,
      category,
      brand: "", // Reset brand when a new category is selected
      model: "", // Reset model when a new category is selected
    }));
    console.log("cateId, ", id);

    setIds({ ...ids, category_id: id, brand_id: id });
  };
  setTimeout(() => {
    console.log(ids);
  }, 2000);

  // Function to handle brand selection
  const handleBrandClick = (brand, id) => {
    setCategoryForm((prevData) => ({
      ...prevData,
      brand,
      model: "", // Reset model when a new brand is selected
    }));
    setIds({ ...ids, brand_id: id });
  };

  // Function to handle model selection
  const handleModelClick = (model, id) => {
    setCategoryForm((prevData) => ({
      ...prevData,
      model,
    }));
    setIds({ ...ids, modal_id: id });
    setCurrentStep(1);
  };

  const defectSubmit = () => {
    if (selectedProblems.length > 0) {
      setCurrentStep(2);
    } else {
      setErrorDefect("Please Select any Defects or type one");
    }
  };

  // Function to add a problem to the selected list
  const addProblem = (problem) => {
    if (!selectedProblems.some((item) => item.id === problem.id)) {
      setSelectedProblems([...selectedProblems, problem]);
    }
  };
  const addProblemInput = (problem) => {
    if (!selectedProblems.some((item) => item.title === problem.title)) {
      const newId = defectsList.length + selectedProblems.length + 1;
      const problemData = {
        id: newId,
        title: problem,
        "isSelected": false
      };
      setSelectedProblems([...selectedProblems, problemData]);
      setSearchIssue('');
    }
  };
  // Function to remove a problem from the selected list
  const removeProblem = (problem) => {
    setSelectedProblems(
      selectedProblems.filter((item) => item.id !== problem.id)
    );
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    getDevices(token);

    if (ids.brand_id && !isNaN(ids.brand_id)) {
      fetchBrands(ids.brand_id).then((res) => {
        setBrandsData(res.data);
      });
    }

    if (ids.brand_id && !isNaN(ids.brand_id)) {
      fetchModels(ids.brand_id,ids.brand_id).then((res) => {
        setModels(res.data);
      });
    }
    fetchDefects().then((res) => {
      setDefectsList(res.data);
    });
  }, [ids]);

  console.log(models);
  const getDevices = async (token) => {
    try {
      const data = await fetchDevices(token).then((res) => {
        setDevices(res.data);
      });
    } catch (err) {
      // setError("Failed to load devices");
      console.error(err);
    }
  };

  function validateMobileNumber(number) {
    // Define a regular expression for validation
    // This example assumes a mobile number format: starts with a '+' followed by country code (optional), then 10-14 digits
    const regex = /^(?:\+?[1-9]\d{1,3}[-.\s]?)?\d{10,14}$/;

    // Check if the number matches the regex
    if (!regex.test(number)) {
        return {
            isValid: false,
            message: "Invalid mobile number format."
        };
    }

    return {
        isValid: true,
        message: "Valid mobile number."
    };
  }
  const formSubmit = async () => {
    if(!validateMobileNumber(formData.phone).isValid) {
      toast.error('Please provide a valid Mobile Number!')
      return false;
    }
    const token = localStorage.getItem("token");
    const device_type = deviceType;
    const DataTable = {
      category_id: ids.category_id,
      brand_id: ids.brand_id,
      defects: [...selectedProblems],
      deliveryType,
      devices: [
        {
          id: ids.modal_id,
          title: categoryForm.model,
          category_id: ids.category_id,
        },
      ],
    };

    if (serialNo) {
      DataTable[deviceType] = serialNo;
    }
    const dataPairs = {
      lead_items: [
        {
          ...DataTable,
        },
      ],
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone: formData.phone,
      address: formData.address,
      zip_code: formData.zip_code,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      message: formData.message,
      reference: formData.reference,
      compliance,
    };

    await CreateLead(dataPairs).then((res) => {
      if (res.success === true) {
        toast.success("We've received your inquiry. Thank you for reaching out.");
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("userDetails", JSON.stringify(res.data.user));
        localStorage.setItem("userType", res.data.user.type);
        setTimeout(() => {
          navigate("/client");
          window.dispatchEvent(new Event("localstorage-update"));
        }, 2000);
        
      } else {
        toast.error("Something went wrong while creating lead, try again later!");
      }
    });
  };
  return (
    <div className="macThemeBG hv-100 showBGAppr">
      <div className="d-flex justify-content-center txt-stale txt-head pt-5">
              {
                currentStep === 0 && !categoryForm?.category && !categoryForm?.brand ? 
                <h2 className="mb-4 primaryTitle">Let’s get started — <span className="colorTheme">choose your device!</span></h2> : ''
              }
              {
                currentStep === 0 && categoryForm?.category && !categoryForm?.brand ? 
                <h2 className="mb-4 primaryTitle">Select the <span className="colorTheme">brand of your device!</span></h2> : ''
              }
              {
                currentStep === 0 && categoryForm?.category  && categoryForm?.brand ? 
                <h2 className="mb-4 primaryTitle">Select the <span className="colorTheme">model you're using!</span></h2> : ''
              }
              {
                currentStep === 1 ? 
                <h2 className="mb-4 primaryTitle">Describe <span className="colorTheme">the issue or problem you're facing!</span></h2> : ''
              }
              {
                currentStep === 2 ? 
                <h2 className="mb-4 primaryTitle">Select Your Preferred <span className="colorTheme">Service Option!</span></h2> : ''
              }
                            {
                currentStep === 3 ? 
                <h2 className="mb-4 primaryTitle">Just a  <span className="colorTheme">Few Details!</span></h2> : ''
              }
      </div>
      <div className="stepper-container">
        <div className="stepper">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`stepper-item ${index <= currentStep ? "active" : ""}`}
            >
              <div className="step-counter">{index + 1}</div>
              <div className="step-name">{step}</div>
            </div>
          ))}
        </div>
      </div>
      {currentStep === 0 && (
        <div className="d-flex container pb-5">
          <div className="row m-0 p-0 w-100 g-0">
            {!categoryForm.category &&
              devices.map((item) => {
                return (
                  <div
                    key={item.id}
                    className="col-6 col-lg-3 col-md-3  g-3"
                    onClick={() => {
                      handleCategoryClick(item.name, item.id);
                    }}
                  >
                    <div className="pointer shadowCustom min-h-100  p-3 card d-flex flex-col justify-content-center align-items-center">
                      <img src={item.image_url} width={50} alt={item.name} />
                      <span className="text-capitalize mt-3 text-center txt-primary txt-p">
                        {item.name}
                      </span>
                    </div>
                  </div>
                );
              })}
            {categoryForm?.category && !categoryForm?.brand && brandsData
              ? brandsData.map((item) => {
                  return (
                    <div
                      key={item.id}
                      className="col-6 col-lg-3 col-md-3  g-3"
                      onClick={() => handleBrandClick(item.name, item.id)}
                    >
                      <div className="pointer shadowCustom min-h-100  p-3 card d-flex flex-col justify-content-center align-items-center"
                      style={{minHeight: "90px"}}
                      >
                        <img src={item.image_url} width={50} alt={item.name} />
                        <span className="text-capitalize mt-1 text-center txt-primary txt-p">
                          {item.name}
                        </span>
                      </div>
                    </div>
                  );
                })
              : ""}
            {categoryForm.brand &&
              models &&
              models.map((model) => {
                return (
                  <div
                    key={model.id}
                    className="col-6 col-lg-3 col-md-3  g-3"
                    onClick={() => handleModelClick(model.title, model.id)}
                  >
                    <div className="pointer shadowCustom min-h-100  p-3 card d-flex flex-col justify-content-center align-items-center">
                      <img src={model.icon} width={50} alt="" />
                      <span className="text-capitalize mt-1 text-center txt-primary txt-p">
                        {model.title}
                      </span>
                    </div>
                  </div>
                );
              })}
            {categoryForm.brand && (
              <>
                {otherModel.isSelected === true ? (
                  <div className="col-6 col-lg-3 col-md-3  g-2">
                    <div className="input-group ">
                      <input
                        type="text"
                        value={otherModel.modelName}
                        onChange={(e) =>
                          setOtherModel({
                            ...otherModel,
                            modelName: e.target.value,
                          })
                        }
                        className="form-control txt-secondary txt-p"
                        style={{
                          paddingTop: "0.75rem",
                          paddingBottom: "0.5rem",
                        }}
                        placeholder="Tell us about the model..."
                      />
                      <span className="input-group-text" id="addon-wrapping">
                        <img width={17} src={toRigthIcon} alt="next" />
                      </span>
                    </div>
                  </div>
                ) : (
                  <div
                    className="col-6 col-lg-3 col-md-3  g-2"
                    onClick={() => {
                      setOtherModel({
                        ...otherModel,
                        isSelected: !otherModel.isSelected,
                      });
                    }}
                  >
                    <div
                      style={{
                        borderColor: otherModel.isSelected
                          ? "#000"
                          : "#0000002d",
                      }}
                      className="min-h-100  p-2 card d-flex flex-col justify-content-center align-items-center"
                    >
                      <span className="text-capitalize mt-1 text-center txt-secondary txt-p">
                        Other
                      </span>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
      {currentStep === 1 && (
        <div className="container">
          <div className="row d-flex ">
            <div className="col-12 col-md-5 col-lg-5">
              <div className="card p-3 text-center mb-4">
                <h4 className="txt-stale">{categoryForm.brand}</h4>
                <span className="txt-secondary f-16 mb-1 ">
                  {categoryForm.model}
                </span>
              </div>
              <div>
                <div className="input-group">
                  <input
                    type="text"
                    onClick={() => setOpenSelect(!openSelect)}
                    value={searchIssue}
                    onChange={(e) => setSearchIssue(e.target.value)}
                    className="form-control"
                    placeholder="Tell us your problem..."
                  />
                  <span
                    className="input-group-text"
                    id="addon-wrapping"
                    onClick={() => addProblemInput(searchIssue)}
                  >
                    <img width={17} src={toRigthIcon} alt="next" />
                  </span>
                </div>
              </div>
              {openSelect && (
                <div className="card my-3 input-search-bar ">
                  {defectsList.map((item) => {
                    return (
                      <>
                        <div
                          onClick={() => addProblem(item)}
                          className="px-2 py-2 "
                          key={item.id}
                        >
                          {item.title}
                        </div>
                        <hr className="m-0 p-0" />
                      </>
                    );
                  })}
                </div>
              )}
            </div>
            <div class="col-md-1 d-none d-md-block">
              <div class="h-100 border-start border-secondary"></div>
            </div>
            <div className="col-12 col-md-5 col-lg-5 d-flex flex-column flex-column-reverse flex-md-column">
              <div className="my-3 txt-stale txt-head">
                <h4 className="mb-3">Get Quote on Defects</h4>
                <p className="txt-p text-danger">{errorDefect}</p>
                <div>
                  {selectedProblems &&
                    selectedProblems.map((item) => {
                      return (
                        <div
                          key={item.id}
                          className="border border-dark rounded p-2 px-2 mb-2 bg-white d-flex justify-content-between align-items-center w-100"
                        >
                          <p className=" txt-p m-0">
                            {item.title}
                          </p>
                          <img
                            onClick={() => removeProblem(item)}
                            src={closeSVG}
                            width={10}
                            alt="close" 
                            className="mx-2"
                          />
                        </div>
                      );
                    })}
                </div>
              </div>
              <Link
                
                className={`bg-black text-center text-white p-2 w-100 text-dec-none ${selectedProblems && selectedProblems?.length > 0 ? "" : "disabled-link"}`}
                onClick={() => defectSubmit()}
              >
                Next
              </Link>
            </div>
          </div>
        </div>
      )}
      {currentStep === 2 && (
        <div className="d-flex container">
          <div className="row m-0 p-0 w-100 g-0">
            {deliveryCat.map((item) => {
              return (
                <div
                  onClick={() => deliveryTypeSubmit(item.name)}
                  key={item.id}
                  className="col-12 col-lg-4 col-md-4  g-3"
                >
                  <div className="pointer shadowCustom min-h-100  p-3 card d-flex flex-col justify-content-center align-items-center">
                    <img src={item.Icon} width={50} alt={item.title} />
                    <span className="text-capitalize mt-1 text-center txt-secondary txt-p">
                      {item.title}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {currentStep === 3 && (
        <div className="container rounded w-100 d-flex flex-column justify-content-center align-items-center">

          <form
            onSubmit={(e) => {
              e.preventDefault();
              formSubmit();
            }}
            className="row w-100 w-md-50 w-lg-50 my-5"
          >
            <div className="col-12 col-lg-6 col-md-6 mb-3">
              <label className="form-label  ">First name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter first name here..."
                required
                value={formData.first_name}
                onChange={(e) => {
                  setFormdata({ ...formData, first_name: e.target.value });
                }}
              />
            </div>
            <div className="col-12 col-lg-6 col-md-6 mb-3">
              <label className="form-label  ">Last name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter last name here..."
                required
                value={formData.last_name}
                onChange={(e) => {
                  setFormdata({ ...formData, last_name: e.target.value });
                }}
              />
            </div>
            <div className="col-12 col-lg-6 col-md-6 mb-3">
              <label className="form-label ">Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter email here..."
                required
                value={formData.email}
                onChange={(e) => {
                  setFormdata({ ...formData, email: e.target.value });
                }}
              />
            </div>
            <div className="col-12 col-lg-6 col-md-6 mb-3">
              <label className="form-label  ">Mobile Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Mobile Number here..."
                required
                value={formData.phone}
                onChange={(e) => {
                  setFormdata({ ...formData, phone: e.target.value });
                }}
              />
            </div>

            <div className="col-12 col-lg-6 col-md-6 mb-3">
              <div className="d-flex ">
                <label className="form-label  ">{deviceType} </label>
                <div
                  className="card mb-2 pb-0 m-1"
                  onClick={() => setTriggerinput(!triggerInput)}
                >
                  <img
                    src={ArrowDown}
                    className=" p-0 mb-0"
                    width={15}
                    alt="arrow"
                  />
                </div>
              </div>
              {triggerInput && (
                <div className="d-flex flex-column card mb-2">
                  <span
                    onClick={() => triggerData("serial_no")}
                    className="pt-2 px-2"
                  >
                    Serial
                  </span>
                  <span
                    onClick={() => triggerData("imei_no")}
                    className="pt-2 px-2 pb-2"
                  >
                    IMEI
                  </span>
                </div>
              )}
              <input
                type="text"
                className="form-control"
                required
                value={serialNo}
                onChange={(e) => setSerialNo(e.target.value)}
              />
            </div>
            <div className="col-12 col-lg-6 col-md-6 mb-3">
              <label className="form-label  ">Address</label>
              <input
                type="text"
                className="form-control"
                required
                placeholder="Enter value here..."
                value={formData.address}
                onChange={(e) => {
                  setFormdata({ ...formData, address: e.target.value });
                }}
              />
            </div>
            <div className="col-12 col-lg-6 col-md-6 mb-3">
              <label className="form-label  ">Zip Code</label>
              <input
                type="text"
                className="form-control"
                required
                placeholder="Enter Zip Code here..."
                value={formData.zip_code}
                onChange={(e) => {
                  setFormdata({ ...formData, zip_code: e.target.value });
                }}
              />
            </div>
            <div className="col-12 col-lg-6 col-md-6 mb-3">
              <label className="form-label    ">City</label>
              <input
                type="text"
                className="form-control"
                required
                placeholder="Enter city name here..."
                value={formData.city}
                onChange={(e) => {
                  setFormdata({ ...formData, city: e.target.value });
                }}
              />
            </div>
            <div className="col-12 col-lg-6 col-md-6 mb-3">
              <label className="form-label  ">State</label>
              <input
                type="text"
                className="form-control"
                required
                placeholder="Enter state name here..."
                value={formData.state}
                onChange={(e) => {
                  setFormdata({ ...formData, state: e.target.value });
                }}
              />
            </div>
            <div className="col-12 col-lg-6 col-md-6 mb-3">
              <label className="form-label  ">Country</label>
              <input
                type="text"
                className="form-control"
                required
                placeholder="Enter your country name here..."
                value={formData.country}
                onChange={(e) => {
                  setFormdata({ ...formData, country: e.target.value });
                }}
              />
            </div>
            <div className="col-12 mb-3 ">
              <label className="form-label  ">Message</label>
              <textarea
                type="text"
                className="form-control"
                required
                placeholder="Describe the issue in detail and tell us about the expectations..."
                value={formData.message}
                onChange={(e) => {
                  setFormdata({ ...formData, message: e.target.value });
                }}
              />
            </div>
            <div className="col-12 mb-3 ">
              <label className="form-label"> How did you hear about us? </label>
              <select
                className="form-select"
                value={formData.reference}
                onChange={handleChangeSelect}
                required
                aria-label="Default select example"
              >
                <option defaultValue>Select any</option>
                {referenceData.map((item) => {
                  return (
                    <option value={item.title} key={item.id}>
                      {item.title}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-12 mb-3 ">
              <div className="form-check">
                <input
                  className="form-check-input"
                  value={compliance}
                  onChange={() => setCompliance(!compliance)}
                  required
                  type="checkbox"
                  defaultValue
                  id="flexCheckDefault"
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                Your Data is Protected (GDPR Compliant)
                </label>
              </div>
            </div>
            <div>
              <button
                className="btn btn-dark custom-width-25 w-100"
                type="submit"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      )}
      {/* <div className="mt-3 container d-flex justify-content-between">
        <button
          className="bg-light btn"
          onClick={handlePrevious}
          disabled={currentStep === 0}
        >
          <img width={20} className="m-1" src={prevSVG} alt="prev" />
        </button>
      
        <button
          className="bg-light btn "
          onClick={handleNext}
          disabled={currentStep === steps.length - 1}
        >
          <img width={20} className="m-1" src={nextSVG} alt="next" />
        </button>
      </div> */}
    </div>
  );
};

export default InqueryForm;
